import { useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import GcPreconCommercial from "./GcPreconCommercial";
import GcDashboard from "../GcDashboard/GcDashboard";
import { useGcLayout } from "../GcLayout";

const GcPreconContainer = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { projectData, preconType } = (location.state ?? {}) as {
    projectData?: unknown;
    preconType?: string;
  };
  const { setCrumbs } = useGcLayout();

  useEffect(() => {
    setCrumbs([
      { label: "My Projects", link: "/gc-dashboard" },
      { label: "Pre-Construction Checklist" },
    ]);
  }, [setCrumbs]);

  if (projectId) {
    return (
      <GcPreconCommercial
        projectId={projectId}
        projectType={preconType}
        projectData={projectData}
        onBackToDashboard={() => navigate("/gc-dashboard")}
      />
    );
  }

  return <GcDashboard />;
};

export default GcPreconContainer;
